import React, { useCallback, useContext } from 'react';
import { ReactFlow, useNodesState, useEdgesState, addEdge, MarkerType } from '@xyflow/react';
import { Card } from 'react-bootstrap';
import '@xyflow/react/dist/style.css';
import { useSelector } from 'react-redux';
import { enum__AppElementType, enum_ENUM_FLUJO_EP } from '../../../../common/Dictionaries';
import { HoverCard, HoverCardType } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { isNullUndefined } from '../../../../common/Helpers';
import { CustomNode, manageDynamicEdges, manageDynamicNodes } from './transversalFunctions';
import { __GetClientRoleCode } from '../../../../common/CommonFuctions';
import MainAppContext from '../../../../MainAppContext';
import { buildFlowNodesAndEdges } from './buildFlowNodesAndEdges';


const FlujoEdPRFADynamicApprove = (props) => {
    const { 
        inputParam_ComponentWidth = '560px',
    } = props;
    

    const nodeTypes = { customNode: CustomNode };
    const { t } = useTranslation();
    const {  _edpPrepareHeader: edpPrepareHeader } = useSelector((state) => state.edpPreparationState);
    const contextSite = useContext(MainAppContext);

    const { nodes: flowNodes, edges: flowEdges } = buildFlowNodesAndEdges({
        edpPrepareHeader,
        contextSite,
    });

    const [nodes, setNodes, onNodesChange] = useNodesState(flowNodes);
    const [edges, setEdges, onEdgesChange] = useEdgesState(flowEdges);
    const onConnect = useCallback((params) => setEdges((els) => addEdge(params, els)), []);

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>     
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-lbl-flow')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                    <div style={{height: '300px', width: inputParam_ComponentWidth}}>
                        <ReactFlow
                            nodeTypes={nodeTypes}
                            nodes={nodes}
                            edges={edges}
                            defaultZoom={0.8}
                            minZoom={0.8}
                            maxZoom={0.8}
                            zoomOnScroll={false}
                            zoomOnPinch={false}
                            zoomOnDoubleClick={false}
                            nodesDraggable={false}
                            panOnDrag={false}
                            panOnScroll={false}
                            onNodesChange={onNodesChange}
                            onEdgesChange={onEdgesChange}
                            onConnect={onConnect}
                            height={500}
                            width={820}
                            connectable={false}
                            elementsSelectable={false}
                            //onNodeMouseEnter={onNodeMouseEnter}
                        />
                        {/*hoverTarget &&*/ false && (
                            <HoverCard
                                type={HoverCardType.plain}
                                target={hoverTarget}
                                plainCardProps={cardProps}
                                cardOpenDelay={0}
                                calloutProps={
                                    { 
                                        preventDismissOnScroll: true,
                                        preventDismissOnResize: true
                                    }
                                }
                            >
                            <span></span>
                            </HoverCard>
                        )}
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default FlujoEdPRFADynamicApprove;